import React from 'react';

import PropTypes from 'prop-types';

import Forecaster from '@asteria/component-forecaster';

const ForecasterView = (props) => {
	const { onAction, onFetch } = props;

	return <Forecaster onAction={onAction} onSubmit={onFetch} />;
};

ForecasterView.displayName = 'ForecasterView';

ForecasterView.propTypes = {
	integrations: PropTypes.shape({
		state: PropTypes.any,
		set: PropTypes.func,
		reset: PropTypes.func,
	}),
	onAction: PropTypes.func,
	onFetch: PropTypes.func,
};

export default React.memo(ForecasterView);
